import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { CartUpdateEvent, ThemeEvents, VariantSelectedEvent } from '@theme/events';
import { DialogComponent, DialogCloseEvent } from '@theme/dialog';
import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion } from '@theme/utilities';
import VariantPicker from '@theme/variant-picker';

(() => {
  if (window.__vodeMobileDrawerRepairLoaded) return;
  window.__vodeMobileDrawerRepairLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function injectMobileDrawerStyles() {
    if (document.getElementById('vode-mobile-drawer-repair-styles')) return;

    const style = document.createElement('style');
    style.id = 'vode-mobile-drawer-repair-styles';
    style.textContent = `
      @media screen and (max-width: 749px) {
        html.vode-menu-open,
        body.vode-menu-open {
          overflow: hidden !important;
        }

        body #Details-menu-drawer-container.menu-drawer-container {
          position: static !important;
        }

        body #Details-menu-drawer-container > .menu-drawer {
          background: #000000 !important;
          border-right: 0 !important;
          box-shadow: 16px 0 42px rgba(0, 0, 0, 0.72) !important;
          color: var(--vode-global-text-color, #f0c85a) !important;
          display: flex !important;
          flex-direction: column !important;
          height: 100dvh !important;
          left: 0 !important;
          max-height: 100dvh !important;
          max-width: 320px !important;
          opacity: 0 !important;
          overflow-y: auto !important;
          position: fixed !important;
          right: auto !important;
          top: 0 !important;
          transform: translate3d(-105%, 0, 0) !important;
          transition: transform 220ms ease, opacity 160ms ease, visibility 160ms ease !important;
          visibility: hidden !important;
          width: min(82vw, 320px) !important;
          z-index: 10060 !important;
        }

        body #Details-menu-drawer-container > .menu-drawer__backdrop {
          background: rgba(0, 0, 0, 0.62) !important;
          height: 100dvh !important;
          inset: 0 !important;
          opacity: 0 !important;
          pointer-events: none !important;
          position: fixed !important;
          transition: opacity 180ms ease, visibility 180ms ease !important;
          visibility: hidden !important;
          width: 100vw !important;
          z-index: 10059 !important;
        }

        body #Details-menu-drawer-container[open] > .menu-drawer,
        body #Details-menu-drawer-container.menu-open > .menu-drawer,
        body #Details-menu-drawer-container.vode-force-open > .menu-drawer {
          opacity: 1 !important;
          transform: translate3d(0, 0, 0) !important;
          visibility: visible !important;
        }

        body #Details-menu-drawer-container[open] > .menu-drawer__backdrop,
        body #Details-menu-drawer-container.menu-open > .menu-drawer__backdrop,
        body #Details-menu-drawer-container.vode-force-open > .menu-drawer__backdrop {
          opacity: 1 !important;
          pointer-events: auto !important;
          visibility: visible !important;
        }

        body #Details-menu-drawer-container[open] .header-drawer-icon--open,
        body #Details-menu-drawer-container.menu-open .header-drawer-icon--open,
        body #Details-menu-drawer-container.vode-force-open .header-drawer-icon--open {
          display: none !important;
        }

        body #Details-menu-drawer-container[open] .header-drawer-icon--close,
        body #Details-menu-drawer-container.menu-open .header-drawer-icon--close,
        body #Details-menu-drawer-container.vode-force-open .header-drawer-icon--close {
          display: block !important;
        }

        body #Details-menu-drawer-container > .menu-drawer .menu-drawer__navigation,
        body #Details-menu-drawer-container > .menu-drawer .menu-drawer__navigation-container,
        body #Details-menu-drawer-container > .menu-drawer .menu-drawer__menu {
          background: #000000 !important;
          color: var(--vode-global-text-color, #f0c85a) !important;
        }

        body #Details-menu-drawer-container > .menu-drawer .menu-drawer__menu {
          padding-inline: 18px !important;
        }

        body #Details-menu-drawer-container > .menu-drawer .menu-drawer__menu-item {
          color: var(--vode-global-text-color, #f0c85a) !important;
          min-height: 48px !important;
          text-shadow: var(--vode-global-text-shadow, 0 0 18px rgba(240, 200, 90, 0.5)) !important;
          -webkit-text-fill-color: var(--vode-global-text-color, #f0c85a) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getDrawerDetails() {
    return document.getElementById('Details-menu-drawer-container');
  }

  function setDrawerOpen(open) {
    const details = getDrawerDetails();
    if (!details) return;

    details.toggleAttribute('open', open);
    details.classList.toggle('menu-open', open);
    details.classList.toggle('vode-force-open', open);
    document.documentElement.classList.toggle('vode-menu-open', open);
    document.body?.classList.toggle('vode-menu-open', open);

    const trigger = details.querySelector('.header__icon--menu');
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function wireMobileDrawer() {
    injectMobileDrawerStyles();

    document.addEventListener(
      'click',
      (event) => {
        if (!mobileQuery.matches) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const details = getDrawerDetails();
        if (!details) return;

        const trigger = target.closest('#Details-menu-drawer-container > summary, .header__icon--menu');
        const closeTarget = target.closest(
          '#Details-menu-drawer-container .menu-drawer__close-button, #Details-menu-drawer-container > .menu-drawer__backdrop'
        );

        if (trigger) {
          const shouldOpen = !details.hasAttribute('open') && !details.classList.contains('menu-open');
          event.preventDefault();
          event.stopImmediatePropagation();
          setDrawerOpen(shouldOpen);
          return;
        }

        if (closeTarget) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setDrawerOpen(false);
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setDrawerOpen(false);
    });

    const handleBreakpointChange = (event) => {
      if (!event.matches) setDrawerOpen(false);
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleBreakpointChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireMobileDrawer, { once: true });
  } else {
    wireMobileDrawer();
  }
})();

export class QuickAddComponent extends Component {
  /** @type {AbortController | null} */
  #abortController = null;
  /** @type {Map<string, Element>} */
  #cachedContent = new Map();
  /** @type {AbortController} */
  #cartUpdateAbortController = new AbortController();

  get productPageUrl() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
    const hotspotProduct = /** @type {import('./product-hotspot').ProductHotspotComponent | null} */ (
      this.closest('product-hotspot-component')
    );
    const productLink = productCard?.getProductCardLink() || hotspotProduct?.getHotspotProductLink();

    if (!productLink?.href) return '';

    const url = new URL(productLink.href);

    if (url.searchParams.has('variant')) {
      return url.toString();
    }

    const selectedVariantId = this.#getSelectedVariantId();
    if (selectedVariantId) {
      url.searchParams.set('variant', selectedVariantId);
    }

    return url.toString();
  }

  /**
   * Gets the currently selected variant ID from the product card
   * @returns {string | null} The variant ID or null
   */
  #getSelectedVariantId() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
    return productCard?.getSelectedVariantId() || null;
  }

  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#closeQuickAddModal);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate, {
      signal: this.#cartUpdateAbortController.signal,
    });
    document.addEventListener(ThemeEvents.variantSelected, this.#updateQuickAddButtonState.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    mediaQueryLarge.removeEventListener('change', this.#closeQuickAddModal);
    this.#abortController?.abort();
    this.#cartUpdateAbortController.abort();
    document.removeEventListener(ThemeEvents.variantSelected, this.#updateQuickAddButtonState.bind(this));
  }

  /**
   * Clears the cached content when cart is updated
   */
  #handleCartUpdate = () => {
    this.#cachedContent.clear();
  };

  /**
   * Re-renders the variant picker in the quick-add modal.
   * @param {Element} newHtml - The element to re-render.
   */
  #updateVariantPicker(newHtml) {
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) return;
    const variantPicker = /** @type {VariantPicker | null} */ (modalContent.querySelector('variant-picker'));
    if (!variantPicker) return;
    variantPicker.updateVariantPicker(newHtml);
  }

  /**
   * Handles quick add button click
   * @param {Event} event - The click event
   */
  handleClick = async (event) => {
    event.preventDefault();

    const currentUrl = this.productPageUrl;

    // Check if we have cached content for this URL
    let productGrid = this.#cachedContent.get(currentUrl);

    if (!productGrid) {
      // Fetch and cache the content
      const html = await this.fetchProductPage(currentUrl);
      if (html) {
        const gridElement = html.querySelector('[data-product-grid-content]');
        if (gridElement) {
          // Cache the cloned element to avoid modifying the original
          productGrid = /** @type {Element} */ (gridElement.cloneNode(true));
          this.#cachedContent.set(currentUrl, productGrid);
        }
      }
    }

    if (productGrid) {
      // Use a fresh clone from the cache
      const freshContent = /** @type {Element} */ (productGrid.cloneNode(true));
      await this.updateQuickAddModal(freshContent);
      this.#updateVariantPicker(productGrid);
    }

    this.#openQuickAddModal();
  };

  #resetScroll() {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    const productDetails = dialogComponent.querySelector('.product-details');
    const productMedia = dialogComponent.querySelector('.product-information__media');
    productDetails?.scrollTo({ top: 0, behavior: 'instant' });
    productMedia?.scrollTo({ top: 0, behavior: 'instant' });
  }

  /** @param {QuickAddDialog} dialogComponent */
  #stayVisibleUntilDialogCloses(dialogComponent) {
    this.toggleAttribute('stay-visible', true);

    dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute('stay-visible', false), {
      once: true,
    });
  }

  #openQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    this.#stayVisibleUntilDialogCloses(dialogComponent);

    dialogComponent.showDialog();

    // is nondeterministic when the open attribute is set on the dialog element after .showDialog() is called.
    // Waiting until the open animation starts seemed to be the most reliable metric here.
    const dialog = dialogComponent.refs?.dialog;
    if (!dialog) return;
    dialog.addEventListener('animationstart', this.#resetScroll.bind(this), { once: true });
  };

  #closeQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    dialogComponent.closeDialog();
  };

  /**
   * Fetches the product page content
   * @param {string} productPageUrl - The URL of the product page to fetch
   * @returns {Promise<Document | null>}
   */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return null;

    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    try {
      const response = await fetch(productPageUrl, {
        signal: this.#abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      return html;
    } catch (error) {
      if (error.name === 'AbortError') {
        return null;
      } else {
        throw error;
      }
    } finally {
      this.#abortController = null;
    }
  }

  /**
   * Re-renders the variant picker.
   * @param {Element} productGrid - The product grid element
   */
  async updateQuickAddModal(productGrid) {
    const modalContent = document.getElementById('quick-add-modal-content');

    if (!productGrid || !modalContent) return;

    if (isMobileBreakpoint()) {
      const productDetails = productGrid.querySelector('.product-details');
      const productFormComponent = productGrid.querySelector('product-form-component');
      const variantPicker = productGrid.querySelector('variant-picker');
      const productPrice = productGrid.querySelector('product-price');
      const productTitle = document.createElement('a');
      productTitle.textContent = this.dataset.productTitle || '';

      // Make product title as a link to the product page
      productTitle.href = this.productPageUrl;

      const productHeader = document.createElement('div');
      productHeader.classList.add('product-header');

      productHeader.appendChild(productTitle);
      if (productPrice) {
        productHeader.appendChild(productPrice);
      }
      productGrid.appendChild(productHeader);

      if (variantPicker) {
        productGrid.appendChild(variantPicker);
      }
      if (productFormComponent) {
        productGrid.appendChild(productFormComponent);
      }

      productDetails?.remove();
    }

    morph(modalContent, productGrid);

    this.#syncVariantSelection(modalContent);
  }

  /**
   * Updates the quick-add button state based on whether a swatch is selected
   * @param {VariantSelectedEvent} event - The variant selected event
   */
  #updateQuickAddButtonState(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.closest('product-card') !== this.closest('product-card')) return;
    const productOptionsCount = this.dataset.productOptionsCount;
    const quickAddButton = productOptionsCount === '1' ? 'add' : 'choose';
    this.setAttribute('data-quick-add-button', quickAddButton);
  }

  /**
   * Syncs the variant selection from the product card to the modal
   * @param {Element} modalContent - The modal content element
   */
  #syncVariantSelection(modalContent) {
    const selectedVariantId = this.#getSelectedVariantId();
    if (!selectedVariantId) return;

    // Find and check the corresponding input in the modal
    const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
    for (const input of modalInputs) {
      if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }
}

if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}

class QuickAddDialog extends DialogComponent {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: this.#abortController.signal });
    this.addEventListener(ThemeEvents.variantUpdate, this.#updateProductTitleLink);

    this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  /**
   * Closes the dialog
   * @param {CartUpdateEvent} event - The cart update event
   */
  handleCartUpdate = (event) => {
    if (event.detail.data.didError) return;
    this.closeDialog();
  };

  #updateProductTitleLink = (/** @type {CustomEvent} */ event) => {
    const anchorElement = /** @type {HTMLAnchorElement} */ (
      event.detail.data.html?.querySelector('.view-product-title a')
    );
    const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */ (this.querySelector('.view-product-title a'));
    const mobileProductTitle = /** @type {HTMLAnchorElement} */ (this.querySelector('.product-header a'));

    if (!anchorElement) return;

    if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
    if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
  };

  #handleDialogClose = () => {
    const iosVersion = getIOSVersion();
    /**
     * This is a patch to solve an issue with the UI freezing when the dialog is closed.
     * To reproduce it, use iOS 16.0.
     */
    if (!iosVersion || iosVersion.major >= 17 || (iosVersion.major === 16 && iosVersion.minor >= 4)) return;

    requestAnimationFrame(() => {
      /** @type {HTMLElement | null} */
      const grid = document.querySelector('#ResultsList [product-grid-view]');
      if (grid) {
        const currentWidth = grid.getBoundingClientRect().width;
        grid.style.width = `${currentWidth - 1}px`;
        requestAnimationFrame(() => {
          grid.style.width = '';
        });
      }
    });
  };
}

if (!customElements.get('quick-add-dialog')) {
  customElements.define('quick-add-dialog', QuickAddDialog);
}

(function sanitizeVodePolicyAddressInfoFromAsset() {
  if (window.location.pathname.indexOf('/policies/') !== 0) return;

  const email = 'wearvode@gmail.com';
  const privacyContactText =
    'Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please email us at ';
  const addressPatterns = [
    /(\s*(?:or\s+)?contact us at\s*)?448\s+E\s+Foothill\s+Blvd,?\s*Suite\s+204,?\s*San\s+Dimas,?\s*CA,?\s*91773,?\s*US\s*/gi,
    /\[INSERT\s+BUSINESS\s+ADDRESS\]/gi,
    /\[INSERT\s+TRADING\s+NAME\]/gi,
    /\[INSERT\s+BUSINESS\s+PHONE\s+NUMBER\]/gi,
    /\[INSERT\s+BUSINESS\s+REGISTRATION\s+NUMBER\]/gi,
    /\[INSERT\s+VAT\s+NUMBER\]/gi,
  ];
  const addressMarkerPattern =
    /448\s+E|Foothill|San\s+Dimas|91773|\[INSERT\s+(?:BUSINESS\s+ADDRESS|TRADING\s+NAME|BUSINESS\s+PHONE\s+NUMBER|BUSINESS\s+REGISTRATION\s+NUMBER|VAT\s+NUMBER)\]/i;

  function cleanAddressText(value) {
    let output = value;
    addressPatterns.forEach((pattern) => {
      output = output.replace(pattern, '');
    });

    return output
      .replace(/please call\s+or\s+email/gi, 'please email')
      .replace(/\s+or\s+contact us at\s*$/gi, '')
      .replace(/\s+([,.])/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function sanitize() {
    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody) return;

    policyBody.querySelectorAll('p').forEach((paragraph) => {
      const text = paragraph.textContent || '';

      if (/privacy practices/i.test(text) && /Privacy Policy/i.test(text) && addressMarkerPattern.test(text)) {
        paragraph.innerHTML = `${privacyContactText}<a href="mailto:${email}">${email}</a>.`;
        return;
      }

      if (/Questions about the Terms of Service/i.test(text) && /Our contact information is posted below/i.test(text)) {
        paragraph.innerHTML = paragraph.innerHTML.replace(
          /<br\s*\/?>\s*Our contact information is posted below:\s*<br\s*\/?>\s*wearvode@gmail\.com\s*(?:<br\s*\/?>\s*)*/i,
          ''
        );
        return;
      }

      if (!addressMarkerPattern.test(text)) return;

      const cleanedText = cleanAddressText(text);
      if (cleanedText !== text.trim()) {
        paragraph.textContent = cleanedText;
      }
    });
  }

  let sanitizeTimer = 0;

  function scheduleSanitize() {
    window.clearTimeout(sanitizeTimer);
    sanitizeTimer = window.setTimeout(sanitize, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSanitize, { once: true });
  } else {
    scheduleSanitize();
  }

  new MutationObserver(scheduleSanitize).observe(document.documentElement, { childList: true, subtree: true });
})();

(function normalizeVodeHomePopupImageSize() {
  if (window.__vodeHomePopupImageSizeNormalized) return;
  window.__vodeHomePopupImageSizeNormalized = true;

  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
  if (!isHomePage) return;

  const popupImageUrl = '/cdn/shop/files/Main_VODE_Hero_Banner.png?v=1778803131&width=1000';

  function injectStyles() {
    if (document.getElementById('vode-home-popup-image-size-normalizer')) return;

    const style = document.createElement('style');
    style.id = 'vode-home-popup-image-size-normalizer';
    style.textContent = `
      .vode-home-popup__panel,
      .vode-home-popup-fallback__panel {
        border-radius: 14px !important;
        min-height: auto !important;
        width: min(90vw, 500px) !important;
      }

      .vode-home-popup__image,
      .vode-home-popup-fallback__image {
        opacity: 0.3 !important;
      }

      .vode-home-popup__shade,
      .vode-home-popup-fallback__shade {
        background: rgba(0, 0, 0, 0.16) !important;
      }

      .vode-home-popup__content,
      .vode-home-popup-fallback__content {
        min-height: auto !important;
        padding: 40px !important;
      }

      .vode-home-popup__heading,
      .vode-home-popup-fallback__heading {
        font-size: 1.75rem !important;
        line-height: 1.05 !important;
      }

      @media screen and (max-width: 749px) {
        .vode-home-popup__panel,
        .vode-home-popup-fallback__panel {
          width: 90% !important;
        }

        .vode-home-popup__content,
        .vode-home-popup-fallback__content {
          padding: 40px 20px !important;
        }

        .vode-home-popup__heading,
        .vode-home-popup-fallback__heading {
          font-size: 1.55rem !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function updateImage() {
    document.querySelectorAll('.vode-home-popup__image, .vode-home-popup-fallback__image').forEach((image) => {
      if (image.getAttribute('src') !== popupImageUrl) {
        image.setAttribute('src', popupImageUrl);
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    });
  }

  function normalize() {
    injectStyles();
    updateImage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize, { once: true });
  } else {
    normalize();
  }

  window.setTimeout(normalize, 750);
  window.setTimeout(normalize, 2500);
  new MutationObserver(normalize).observe(document.documentElement, { childList: true, subtree: true });
})();

(function initVodeHomePopupFallback() {
  return;
  if (window.__vodeHomePopupFallbackLoaded) return;
  window.__vodeHomePopupFallbackLoaded = true;

  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
  if (!isHomePage) return;

  const storageKey = 'vode-home-popup-dismissed-fallback';
  const forceOpen = new URLSearchParams(window.location.search).get('vode_popup') === '1';

  function wasClosed() {
    try {
      return window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function persistClosed() {
    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Session storage can be unavailable in strict privacy contexts.
    }
  }

  function injectStyles() {
    if (document.getElementById('vode-home-popup-fallback-styles')) return;

    const style = document.createElement('style');
    style.id = 'vode-home-popup-fallback-styles';
    style.textContent = `
      .vode-home-popup-fallback{display:none;inset:0;isolation:isolate;position:fixed;z-index:10030}
      .vode-home-popup-fallback.is-active{align-items:center;display:grid;justify-items:center}
      .vode-home-popup-fallback__overlay{background:rgba(0,0,0,.74);cursor:pointer;inset:0;position:fixed}
      .vode-home-popup-fallback__panel{background:#050505;border:1px solid rgba(240,200,90,.58);border-radius:14px;box-shadow:0 0 34px rgba(240,200,90,.28),0 18px 70px rgba(0,0,0,.76);color:var(--vode-global-text-color,#f0c85a);overflow:hidden;position:relative;width:min(90vw,500px)}
      .vode-home-popup-fallback__image,.vode-home-popup-fallback__shade{inset:0;position:absolute}
      .vode-home-popup-fallback__image{height:100%;object-fit:cover;opacity:.3;width:100%}
      .vode-home-popup-fallback__shade{background:rgba(0,0,0,.16)}
      .vode-home-popup-fallback__close{align-items:center!important;background:linear-gradient(rgba(0,0,0,.7),rgba(0,0,0,.7)) padding-box,var(--vode-global-text-gradient,linear-gradient(115deg,#fff4b0,#f2c94c,#7b4d12,#f7d878)) border-box!important;border:1px solid transparent!important;border-radius:999px!important;color:var(--vode-global-text-color,#f0c85a)!important;display:grid!important;height:34px!important;min-height:34px!important;padding:0!important;place-items:center!important;position:absolute;right:14px;top:14px;width:34px!important;z-index:3;-webkit-text-fill-color:var(--vode-global-text-color,#f0c85a)!important}
      .vode-home-popup-fallback__close svg{fill:none;height:16px;stroke:currentcolor;stroke-linecap:round;stroke-width:2;width:16px}
      .vode-home-popup-fallback__content{align-items:center;display:grid;padding:40px;position:relative;text-align:center;z-index:2}
      .vode-home-popup-fallback__form{margin:0 auto;max-width:380px;width:100%}
      .vode-home-popup-fallback__progress{display:flex;gap:8px;justify-content:center;margin-bottom:20px}
      .vode-home-popup-fallback__dot{background:rgba(240,200,90,.28);border-radius:999px;height:8px;width:8px}
      .vode-home-popup-fallback__dot.is-active{background:var(--vode-global-text-color,#f0c85a);box-shadow:0 0 12px rgba(240,200,90,.85)}
      .vode-home-popup-fallback__step{display:none}
      .vode-home-popup-fallback__step.is-active{display:block}
      .vode-home-popup-fallback__eyebrow{font-size:.72rem;font-weight:800;letter-spacing:0;margin:0 0 12px;text-transform:uppercase}
      .vode-home-popup-fallback__heading{background-image:var(--vode-global-text-gradient,linear-gradient(115deg,#fff4b0,#f2c94c,#7b4d12,#f7d878));background-clip:text;color:transparent!important;font-size:1.75rem;line-height:1.05;margin:0 0 16px;text-shadow:var(--vode-global-text-shadow,0 0 18px rgba(240,200,90,.5));-webkit-background-clip:text;-webkit-text-fill-color:transparent}
      .vode-home-popup-fallback__subtext,.vode-home-popup-fallback__consent{color:var(--vode-global-text-color,#f0c85a);margin:0 auto 22px;max-width:31ch;text-shadow:var(--vode-global-text-shadow,0 0 18px rgba(240,200,90,.5))}
      .vode-home-popup-fallback__field{display:block;margin-bottom:14px}
      .vode-home-popup-fallback__field input{background:rgba(0,0,0,.76)!important;border:1px solid rgba(240,200,90,.72)!important;border-radius:0!important;box-shadow:0 0 18px rgba(240,200,90,.16);color:var(--vode-global-text-color,#f0c85a)!important;font-size:1rem;min-height:52px;padding:0 16px;width:100%;-webkit-text-fill-color:var(--vode-global-text-color,#f0c85a)!important}
      .vode-home-popup-fallback__field input::placeholder{color:rgba(240,200,90,.72)!important;-webkit-text-fill-color:rgba(240,200,90,.72)!important}
      .vode-home-popup-fallback__button{background:linear-gradient(#000,#000) padding-box,var(--vode-global-text-gradient,linear-gradient(115deg,#fff4b0,#f2c94c,#7b4d12,#f7d878)) border-box!important;border:2px solid transparent!important;border-radius:0!important;color:var(--vode-global-text-color,#f0c85a)!important;font-weight:900;min-height:54px;text-transform:uppercase;width:100%;-webkit-text-fill-color:var(--vode-global-text-color,#f0c85a)!important}
      .vode-home-popup-fallback__error,.vode-home-popup-fallback__success{display:none;font-size:.92rem;margin:14px 0 0}
      .vode-home-popup-fallback__error.is-visible{color:#ff9d8e;display:block}
      .vode-home-popup-fallback__success.is-visible{color:var(--vode-global-text-color,#f0c85a);display:block;font-size:1.45rem;font-weight:900;text-transform:uppercase}
      .vode-home-popup-fallback__consent{font-size:.72rem;line-height:1.45;margin-top:16px;opacity:.82}
      @media screen and (max-width:749px){.vode-home-popup-fallback__panel{width:90%}.vode-home-popup-fallback__content{padding:40px 20px}.vode-home-popup-fallback__heading{font-size:1.55rem}}
    `;
    document.head.appendChild(style);
  }

  function createPopup() {
    if (document.querySelector('vode-home-popup, .vode-home-popup-fallback')) return null;

    injectStyles();

    const popup = document.createElement('div');
    popup.className = 'vode-home-popup-fallback';
    popup.setAttribute('aria-hidden', 'true');
    popup.innerHTML = `
      <div class="vode-home-popup-fallback__overlay" data-vode-popup-close></div>
      <div class="vode-home-popup-fallback__panel" role="dialog" aria-modal="true" aria-labelledby="vode-home-popup-fallback-heading">
        <img class="vode-home-popup-fallback__image" src="/cdn/shop/files/Main_VODE_Hero_Banner.png?v=1778803131&width=1000" alt="" loading="lazy">
        <div class="vode-home-popup-fallback__shade"></div>
        <button type="button" class="vode-home-popup-fallback__close" aria-label="Close popup" data-vode-popup-close>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
        <div class="vode-home-popup-fallback__content">
          <form class="vode-home-popup-fallback__form" method="post" action="/contact#vode-home-popup-fallback" novalidate>
            <input type="hidden" name="form_type" value="contact">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[subject]" value="Homepage popup signup">
            <input type="hidden" name="contact[body]" value="Homepage popup signup for VODE drop updates.">
            <div class="vode-home-popup-fallback__progress" aria-hidden="true">
              <span class="vode-home-popup-fallback__dot is-active" data-vode-popup-dot="1"></span>
              <span class="vode-home-popup-fallback__dot" data-vode-popup-dot="2"></span>
            </div>
            <div class="vode-home-popup-fallback__step is-active" data-vode-popup-step="1">
              <p class="vode-home-popup-fallback__eyebrow">DROP ACCESS</p>
              <h2 class="vode-home-popup-fallback__heading" id="vode-home-popup-fallback-heading">Stay in the loop</h2>
              <p class="vode-home-popup-fallback__subtext">Enter your email for first access to VODE drops.</p>
              <label class="vode-home-popup-fallback__field">
                <span class="visually-hidden">Email address</span>
                <input type="email" name="contact[email]" autocomplete="email" placeholder="Email address" required data-vode-popup-email>
              </label>
              <button type="button" class="vode-home-popup-fallback__button" data-vode-popup-next>Continue</button>
              <p class="vode-home-popup-fallback__error" data-vode-popup-email-error>Please enter a valid email address.</p>
            </div>
            <div class="vode-home-popup-fallback__step" data-vode-popup-step="2">
              <p class="vode-home-popup-fallback__eyebrow">DROP ACCESS</p>
              <h2 class="vode-home-popup-fallback__heading">Add your number</h2>
              <p class="vode-home-popup-fallback__subtext">Get SMS updates when the first drop opens.</p>
              <label class="vode-home-popup-fallback__field">
                <span class="visually-hidden">Phone number</span>
                <input type="tel" name="contact[phone]" autocomplete="tel" placeholder="Phone number" required data-vode-popup-phone>
              </label>
              <button type="submit" class="vode-home-popup-fallback__button" data-vode-popup-submit>Submit</button>
              <p class="vode-home-popup-fallback__error" data-vode-popup-phone-error>Please enter a valid phone number.</p>
              <p class="vode-home-popup-fallback__consent">By submitting, you agree to receive VODE email and SMS updates. Message and data rates may apply.</p>
              <p class="vode-home-popup-fallback__success" data-vode-popup-success>You're on the list.</p>
            </div>
          </form>
        </div>
      </div>
    `;

    document.body.appendChild(popup);
    return popup;
  }

  function wirePopup(popup) {
    const form = popup.querySelector('form');
    const emailInput = popup.querySelector('[data-vode-popup-email]');
    const phoneInput = popup.querySelector('[data-vode-popup-phone]');
    const emailError = popup.querySelector('[data-vode-popup-email-error]');
    const phoneError = popup.querySelector('[data-vode-popup-phone-error]');
    const success = popup.querySelector('[data-vode-popup-success]');
    const submitButton = popup.querySelector('[data-vode-popup-submit]');

    function open() {
      popup.classList.add('is-active');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close(remember) {
      popup.classList.remove('is-active');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (remember) persistClosed();
    }

    function setStep(stepNumber) {
      popup.querySelectorAll('[data-vode-popup-step]').forEach((step) => {
        step.classList.toggle('is-active', step.dataset.vodePopupStep === String(stepNumber));
      });
      popup.querySelectorAll('[data-vode-popup-dot]').forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.vodePopupDot) <= stepNumber);
      });
    }

    function validEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function validPhone(value) {
      return value.replace(/\D/g, '').length >= 10;
    }

    popup.querySelectorAll('[data-vode-popup-close]').forEach((button) => {
      button.addEventListener('click', () => close(true));
    });

    popup.querySelector('[data-vode-popup-next]')?.addEventListener('click', () => {
      if (!validEmail(emailInput.value)) {
        emailError.classList.add('is-visible');
        emailInput.focus();
        return;
      }
      emailError.classList.remove('is-visible');
      setStep(2);
      phoneInput.focus();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      phoneError.classList.remove('is-visible');

      if (!validEmail(emailInput.value)) {
        setStep(1);
        emailError.classList.add('is-visible');
        emailInput.focus();
        return;
      }

      if (!validPhone(phoneInput.value)) {
        setStep(2);
        phoneError.classList.add('is-visible');
        phoneInput.focus();
        return;
      }

      submitButton.disabled = true;

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
        });

        if (!response.ok) throw new Error('Contact form submit failed');

        success.classList.add('is-visible');
        persistClosed();
        window.setTimeout(() => close(false), 2400);
      } catch (error) {
        phoneError.textContent = 'Please try again.';
        phoneError.classList.add('is-visible');
        submitButton.disabled = false;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-active')) close(true);
    });

    if (forceOpen || !wasClosed()) {
      window.setTimeout(open, forceOpen ? 0 : 2000);
    }
  }

  function init() {
    if (document.querySelector('vode-home-popup')) return;
    const popup = createPopup();
    if (popup) wirePopup(popup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
